import{createAnimate as t}from"./create-animate.es.js";import{Animation as i}from"../../../animation/dist/Animation.es.js";const o=t(i);export{o as animate};
